export default class Sam3 {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async segment(asset_id, prompt_type, { prompt = null, x = null, y = null, websocketsToken = null } = {}) {
        const formData = new FormData();
        formData.append('asset_id', asset_id);
        formData.append('prompt_type', prompt_type);
        formData.append('websocketsToken', websocketsToken);
        if (prompt != null) {
            formData.append('prompt', prompt);
        }
        if (x != null) {
            formData.append('x', String(x));
        }
        if (y != null) {
            formData.append('y', String(y));
        }
        if (sessionStorage.getItem('project_id')) {
            formData.append('project_id', sessionStorage.getItem('project_id'));
        }
        return this.api.post_with_token('/sam3/segment', formData);
    }
}
